<div class="search-results-infinite panel panel-default" tabindex="0">
    @if (results.length > 0) {
        <div
            class="search-scroll"
            infiniteScroll
            (infiniteScrollNext)="getResults()"
            infiniteScrollTargetClass="list-group-item"
        >
            <div class="list-group">
                @for (result of results; track result; let i = $index) {
                    <span
                        (click)="navigate(result, i, $event)"
                        (mouseover)="hoverIn(i)"
                        class="list-group-item list-group-item-action clickable"
                        [ngClass]="'search-result-' + i"
                        [attr.data-qa]="'search-result-' + i"
                        tabindex="0"
                        (keyup)="keyup($event, i)"
                        style="border: initial; border-top: 1px solid var(--ace-neutral-200)"
                        [ngStyle]="{ 'min-height': result.status !== 'Active' ? '70px' : '30px' }"
                    >
                        @if (criteria.resultType === 'parcel') {
                            <search-result-parcel [result]="result"></search-result-parcel>
                        }
                        @if (criteria.resultType === 'company') {
                            <search-result-company [result]="result"></search-result-company>
                        }
                        @if (criteria.resultType === 'site') {
                            <search-result-site [result]="result"></search-result-site>
                        }
                        @for (extraFilter of extraFilters | sortBy: 'sequenceNum'; track extraFilter) {
                            <p class="mb-0">
                                <search-result-extra [result]="result" [filter]="extraFilter"></search-result-extra>
                            </p>
                        }
                    </span>
                }
            </div>
        </div>
    }
    @if (results && results.length === 0 && !loading) {
        <p class="lead" data-qa="quick-search-no-results">No Results Found</p>
    }
    @if (loading && allowToShowSpinner) {
        <ws-ace-loader></ws-ace-loader>
    }
</div>
